<template>
  <div v-if="keyActive === keyAudio" class="action action-txt">
    <div class="action_wrap">
      <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold book-viewer__cats__wrap">
        Âm thanh
      </h2>
      <div class="action__detail">
        <div class="action__upload book-viewer__cats__wrap">
          <a href="javascript:;" class="btn btn-main font-size-16 border-rd-20 form-file-hide" @click="openModalFileUploaded">
            <i class="icon-upload color-light"></i>
            Tải lên
            <!-- <input type="file" id="file_audio" ref="file_audio" @change="uploadAudio()"> -->
          </a>
        </div>
        <div class="action__section">
          <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold book-viewer__cats__wrap">Âm thanh có sẵn</label>
          <SidebarFilter class="book-viewer__cats__wrap" />
          <vue-custom-scrollbar class="action__section__list action__section__list--data action__section__list--data--scroll">
            <div v-if="audios && audios.length > 0" class="book-viewer__cats__wrap display-flex-wrap">
              <ItemDataAction v-for="(item, index) of audios" :key="index" :dataSource="item" :position="index" />
            </div>
            <p v-else class="secondary-color-txt font-size-16 book-viewer__cats__wrap text-center">Không tìm thấy dữ liệu phù hợp</p>
            <div v-if="audios && audios.length > 0" id="audios__end"></div>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>
    <ModalFileUploaded v-if="isOpenModalFileUploaded" :fileType="fileType" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ItemDataAction from './ItemDataAction.vue'
import fileService from './../../_api/fileService'
import SidebarFilter from './SidebarFilter.vue'
import { STORE_KEY, MEDIA_TYPE_AUDIO, KEY_AUDIO, FILE_TYPE_UPLOADED_AUDIO } from './../../_store/constants'
import mixinsDetailLesson from './../../_store/mixinsDetailLesson'
import ModalFileUploaded from './ModalFileUploaded.vue'

export default {
  name: 'SidebarActionAudio',
  mixins: [ mixinsDetailLesson ],
  props: {
    keyActive: String
  },
  components: {
    ItemDataAction,
    SidebarFilter,
    vueCustomScrollbar,
    ModalFileUploaded
  },
  data () {
    return {
      audios: [],
      paramSearch: {},
      file: {},
      keyAudio: KEY_AUDIO,
      elmEndItem: null,
      observer: null,
      fileType: MEDIA_TYPE_AUDIO
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['mediaPreviewData', 'paramsSearchMediaDetail', 'idModalFileUploaded', 'isOpenModalFileUploaded'])
  },
  watch: {
    keyActive (newVal) {
      newVal === KEY_AUDIO && this.acSetParamSearchMediaDetail({...this.paramsSearchMediaDetail, classId: 0, subjectId: 0, keyword: '', documentTypeId: MEDIA_TYPE_AUDIO, pageIndex: 1})
    },

    paramsSearchMediaDetail () {
      this.keyActive === KEY_AUDIO && this.getAudios()
    }
  },
  beforeDestroy () {
    this.observer && this.observer.unobserve(this.elmEndItem);
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetMediaPreview', 'acSetParamSearchMediaDetail', 'acSetVisibleModalFileLoaded']),

    handleChangeKeyFilter (val) {
      this.paramSearch = val
      this.keyActive === KEY_AUDIO && this.getAudios()
    },

    getAudios () {
      let self = this;
      self.setLoading(true);


      fileService.filterDataMedias(self.paramsSearchMediaDetail)
      .then((res) => {
        if (res) {
          self.audios = self.paramsSearchMediaDetail.pageIndex === 1 ? [...res.list] : [...self.audios, ...res.list]
          self.acSetMediaPreview(self.paramsSearchMediaDetail.pageIndex === 1 ? [...res.list] : [...self.mediaPreviewData, ...res.list])
          return res.list
        }
      })
      .then(data => {
        if (data && data.length > 0 && !self.observer) {
          // SetTimeout for render list to html
          setTimeout(() => {
            self.mountedScroll()
          }, 1500)
        }
      })
      .finally(() => { self.setLoading(false)})
    },

    mountedScroll () {
      this.elmEndItem = document.getElementById('audios__end')
      if (this.elmEndItem && !this.observe) {
        this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
        this.observer.observe(this.elmEndItem)
      }
    },

    handleScrollEnd () {
      this.acSetParamSearchMediaDetail({...this.paramsSearchMediaDetail, pageIndex: this.paramsSearchMediaDetail.pageIndex + 1})
    },

    async openModalFileUploaded () {
      await this.acSetVisibleModalFileLoaded(true)
      this.$bvModal.show(this.idModalFileUploaded)
    },

    uploadAudio() {
        let self = this;
        self.setLoading(true);
        this.file = this.$refs.file_audio.files[0];
        let isValid = false;
        if (this.file.type !== '' && this.file.type.split('/').length === 2 && this.file.type.split('/')[0] === 'audio') {
          isValid = true;
        }
        if (!isValid) {
          self.$toast.error('Vui lòng chọn file đúng định dạng')
          self.setLoading(false)
        } else {
          let fileData = { name: this.file.name, fileExt: this.file.type.split('/')[1], fileSize: this.file.size, fileType: MEDIA_TYPE_AUDIO };
          let formData = new FormData();
          formData.append('file', this.file);
          fileService.upload(formData).then((response) => {
            if (response.data.status == 'success') {
              fileData.fileRef = response.data.data;
              self.saveMediaFile(fileData);
            }
          }).finally(() => self.setLoading(false));
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>